"use strict";

require("core-js/modules/es.string.trim");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var isLocalPhone = function isLocalPhone(message) {
  return function (_ref) {
    var field = _ref.field;

    if (!field.value) {
      return true;
    }

    var isValid = false;
    var strVal = typeof field.value === 'string' ? field.value.trim() : field.value;
    var containsNoLetters = !/([a-zA-Z])+/.test(strVal);
    var isLength = strVal.length === 10;
    var isNumbers = /^([0-9]*$)+/.test(strVal);

    if (containsNoLetters) {
      isValid = isLength && isNumbers;
    }

    return [isValid, message || 'Please enter phone number with numbers only.'];
  };
};

var _default = isLocalPhone;
exports.default = _default;
//# sourceMappingURL=isLocalPhone.js.map